module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('v-card-text', [_c('v-container', {
    staticClass: "grey lighten-4",
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('h2', [_vm._v("Os seguintes recursos estão disponíveis em caso de dúvidas:")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', [_c('v-card', [_c('v-card-title', [_vm._v("Perguntas Frequentes:")]), _vm._v(" "), _c('v-card-text', [_c('p', [_vm._v("Respostas para as dúvidas mais comuns sobre o sistema e procedimentos realizados pela PRPPG.")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Perguntas Frequentes")])])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', [_c('v-card', [_c('v-card-title', [_vm._v("Orientações Gerais:")]), _vm._v(" "), _c('v-card-text', [_c('p', [_vm._v("Está com dúvidas sobre como registrar um projeto de pesquisa? Acesse os arquivos abaixo:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Arquivo 1")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Arquivo 2")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Arquivo 3")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Para obter maiores informações sobre os Objetivos de Desenvolvimento Sustentável (ODS), clique nos links abaixo:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://ods.ufes.br/",
      "target": "_blank"
    }
  }, [_vm._v("UFES - Objetivos de Desenvolvimento Sustentável")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.agenda2030.com.br/",
      "target": "_blank"
    }
  }, [_vm._v("Plataforma Agenda 2030")])])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', [_c('v-card', [_c('v-card-title', [_vm._v("Fale Conosco:")]), _vm._v(" "), _c('v-card-text', [_c('p', [_vm._v("Sistema de suporte da aplicação, que deve ser utilizado caso não consiga resolver sua dúvida com as orientações gerais ou com as perguntas frequentes.")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Sistema de Suporte")])])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b57dcd6c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/pesquisa/ajuda-pesquisa.vue
// module id = 933
// module chunks = 0